/*
 * @Author: hippo
 * @Date: 2023-10-31 10:00:30
 * @LastEditors: hippo
 * @LastEditTime: 2023-11-08 12:30:52
 * @FilePath: /subang-console/src/containers/workspace/components/TenantStatusBadge/index.js
 * @Description: 
 * 
 * Copyright (c) 2023 by ${git_name_email}, All Rights Reserved. 
 */
import React from 'react'
import { Avatar, Tooltip } from 'antd'
import StatusBadge from '@/components/StatusBadge';
import { orderStatus } from '@/models/orders/defines/constants';

const tenantMode = process.env.APP_MODE === 'tenant'
const isManagerMode = process.env.APP_MODE === 'manager';

export default function TenantStatusBadge(props) {
  let { text = '商家指派', order, style = {} } = props
  if(order?.is_retail){
    text = '散户指派'
  }
  return (
    <>
      {(
        // isManagerMode &&
        //order?.status_code == orderStatus.WAIT_ASSIGN &&
        order?.ticket_type == 2
      ) && <StatusBadge style={{ color: '#ffffff', background: '#ca4141', ...style }}>
          {text}
        </StatusBadge>
      }
    </>
  )
}
